import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "info-row" }
const _hoisted_2 = { class: "value" }
const _hoisted_3 = { class: "info-row" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "info-row" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "dialog-footer" }

import { ref, watch, reactive } from 'vue';
import { ElMessage, type FormInstance, type FormRules } from 'element-plus';
import { useApi } from '@/hooks/useApi';


export default /*@__PURE__*/_defineComponent({
  __name: 'post',
  props: {
    modelValue: { type: Boolean },
    orderData: {}
  },
  emits: ["update:modelValue", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = ref(false);
const formRef = ref<FormInstance>();
const submitting = ref(false);

// 表单数据
const formData = reactive({
  postcode: '',
});

// 表单验证规则
const rules: FormRules = {
  postcode: [
    { required: true, message: '请输入快递单号', trigger: 'blur' },
    { min: 5, max: 50, message: '快递单号长度应在5-50个字符之间', trigger: 'blur' },
  ],
};

// 重置表单
const resetForm = () => {
  formData.postcode = '';
  formRef.value?.clearValidate();
};

// 监听props变化
watch(() => props.modelValue, (newVal) => {
  visible.value = newVal;
  if (newVal) {
    // 重置表单
    resetForm();
  }
}, { immediate: true });

// 监听visible变化
watch(visible, (newVal) => {
  emit('update:modelValue', newVal);
});

// 关闭弹窗
const handleClose = () => {
  visible.value = false;
};

// 提交发货
const handleSubmit = async() => {
  if (!formRef.value) {
    return;
  }

  try {
    const valid = await formRef.value.validate();
    if (!valid) {
      return;
    }

    submitting.value = true;

    await useApi().billApi.shipBillbill({
      billId: props.orderData.id,
      postcode: formData.postcode,
    });

    ElMessage.success('发货成功');
    emit('success');
    handleClose();
  } catch (error) {
    ElMessage.error('发货失败，请重试');
    console.error('发货失败:', error);
  } finally {
    submitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: "订单发货",
    width: "500px",
    "before-close": handleClose,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit,
          loading: submitting.value
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode(" 确认发货 ")
          ])),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        rules: rules,
        "label-width": "100px",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            class: "order-info",
            shadow: "never"
          }, {
            header: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("span", null, "订单信息", -1)
            ])),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label" }, "订单编号：", -1)),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.orderData.id || '无'), 1)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "label" }, "收货人：", -1)),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.orderData.postinfo?.name || '无'), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "联系电话：", -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.orderData.postinfo?.phone || '无'), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "收货地址：", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.orderData.postinfo?.address || '无'), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "快递单号",
            prop: "postcode",
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.postcode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.postcode) = $event)),
                placeholder: "请输入快递单号",
                clearable: "",
                maxlength: "50",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})